import React from "react";
import { GitCompare, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function DkSenaryoPanel({ senaryo, loading, onHesapla }) {
    return (
        <div className="rounded-xl border border-cyan-500/20 bg-cyan-500/5 p-4 space-y-3">
            <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                    <h4 className="text-sm font-medium text-cyan-200 flex items-center gap-2">
                        <GitCompare className="h-4 w-4" />
                        Kusur senaryoları
                    </h4>
                    <p className="text-[10px] text-slate-500">Tahkim stratejisi için %0 / %30 / %50 karşılaştırma</p>
                </div>
                <Button size="sm" variant="outline" disabled={loading} onClick={onHesapla}>
                    {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Senaryo hesapla"}
                </Button>
            </div>
            {senaryo?.senaryolar?.length ? (
                <div className="grid sm:grid-cols-3 gap-2">
                    {senaryo.senaryolar.map((s, i) => (
                        <div
                            key={i}
                            className="rounded-lg border border-white/10 bg-black/30 p-3 text-center"
                        >
                            <div className="text-[10px] text-slate-500 uppercase">{s.etiket}</div>
                            <div className="text-lg font-display text-emerald-300 mt-1">
                                {s.gercek_deger_kaybi_fmt || "—"}
                            </div>
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
}
